import { Controller } from 'stimulus';
import Splide from '@splidejs/splide';

window.bindSlider = function(element, autoplay) {
  // initSlider() rebinds every .splide on the page on each controller connect, not just its
  // own - on a page with more than one data-controller="slider" (e.g. companies/index, which
  // has one for Learning Journeys, one for Llama Bites, and now one for the Home Hero), an
  // already-mounted element would otherwise get a second, orphaned Splide instance stacked on
  // top of the first. Splide marks its root "is-initialized" once mounted, so skipping that
  // case here keeps the single real instance instead of piling up duplicates.
  if (element.classList.contains('is-initialized')) return;

  // Off by default (every existing carousel here relies on that); opt in per-element via
  // data-arrows="true" rather than flipping it for every .splide on the page.
  const splide = new Splide(element, { type: 'slide', autoplay: autoplay, drag: false, arrows: element.dataset.arrows === 'true' });
  splide.mount();
  element.splide = splide;
}

export default class extends Controller {
  static targets = ['slider'];

  splide = null;

  connect() {

    if (this.hasSliderTarget) {
      this.initSlider(false);
      this.splide = this.sliderTarget.splide;
      this.splide.on('move', () => {
        this.toggleButtons();
      });
    } else {
      this.initSlider()
    }
  }

  initSlider(autoplay = true) {
    $('.splide').each((i, element) => {
      bindSlider(element, autoplay);
    });
  }

  moveSlide(event) {
    const forward = parseInt(event.target.dataset.forward, 10);
    let moveToIndex = forward ? (this.splide.index + 1) % this.splide.length : (this.splide.index - 1 + this.splide.length) % this.splide.length;
    this.toggleButtons();
    this.splide.go(moveToIndex);
  }

  toggleButtons() {
    if (this.splide.index === this.splide.length - 1) {
      $('#fowardable').removeClass('d-flex').addClass('d-none');
      $('#backwardable').removeClass('d-none').addClass('d-flex');
    } else {
      $('#backwardable').removeClass('d-flex').addClass('d-none');
      $('#fowardable').removeClass('d-none').addClass('d-flex');
    }
  }
}
